import { render, staticRenderFns } from "./apple.vue?vue&type=template&id=ceaf4540&scoped=true&"
import script from "./apple.vue?vue&type=script&lang=js&"
export * from "./apple.vue?vue&type=script&lang=js&"
import style0 from "./apple.vue?vue&type=style&index=0&id=ceaf4540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaf4540",
  null
  
)

export default component.exports